<template>
  <main-layout>

    <div slot="left-side">
      <menubar screenIdParam="M-06-24"></menubar>
    </div>

    <!--  メインページ 開始  -->
    <el-row slot="header">
      <head-title>
        <label slot="title">{{ $t("label.system.tenant.detail.googleCalendarAuth") }}</label>
        <lvory-but
          v-if="this.$authCodeCheck('010611') && isClearBtn"
          slot="cancel"
          class="header-clear-btn"
          @click="deleteGoogleCalendarAuth">
          {{ $t("button.common.cancelNarrow") }}
        </lvory-but>
        <narrow-down
          v-if="this.$authCodeCheck('010611')"
          slot="create"
          class="header-save-btn"
          @click="editGoogleCalendarAuth">
          {{ $t("button.common.data.save") }}
        </narrow-down>
      </head-title>
    </el-row>

    <div slot="body">

      <el-form
        ref="ruleForm"
        :rules="rules"
        :model="form"
        class="c-auth-form"
        label-width="188px"
        label-position="left"
        hide-required-asterisk>

        <!-- ドメイン -->
        <el-form-item
          v-if="this.$authCodeCheck('010611')"
          prop="domain"
          class="m-bottom-5 client-id master-start"
          :label="this.$t('label.system.tenant.googleAuth.domain')">
          <el-input
            maxlength="256"
            v-model="form.domain">
          </el-input>
        </el-form-item>
        <!-- ドメイン TEXT-->
        <el-form-item
          v-else
          class="m-bottom-5 client-id"
          :label="this.$t('label.system.tenant.googleAuth.domain')">
          <div class="domain">
            <span>{{ form.domain }}</span>
          </div>
        </el-form-item>

        <!-- クライアントID -->
        <el-form-item
          v-if="this.$authCodeCheck('010611')"
          prop="clientId"
          class="m-bottom-5 client-id master-start"
          :label="this.$t('label.system.tenant.googleAuth.clientId')">
          <el-input
            maxlength="256"
            v-model="form.clientId">
          </el-input>
        </el-form-item>

        <!-- シークレットキー -->
        <el-form-item
          v-if="this.$authCodeCheck('010611')"
          prop="secretKey"
          class="master-start"
          :label="this.$t('label.system.tenant.googleAuth.secretKey')">
          <el-input
            :rows="5"
            type="textarea"
            v-model="form.secretKey"
            maxlength="3000">
          </el-input>
        </el-form-item>

      </el-form>

      <div
        v-if="this.$authCodeCheck('010611')"
        class="c-auth-save-btn">
        <narrow-down
          @click="editGoogleCalendarAuth">
          {{ $t("button.common.data.save") }}
        </narrow-down>
      </div>

      <loading-dialog :dialogVisible="showLoading" />

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="deleteIsShow"
        :msgParam="deleteMsgParam"
        @on-isPassParam="deleteAuthInfo">
      </el-dialog-prompt>

      <el-dialog-prompt
        :centerDialogVisibleParam.sync="saveIsShow"
        :msgParam="saveMsgParam"
        @on-isPassParam="editAuthInfo">
      </el-dialog-prompt>
    </div>

  </main-layout>
</template>

<script>
import Menubar from "@/components/leftmenu/DashBoard"
import LvoryBut from "@/components/common/generalButton/LvoryBut"
import HeadTitle from "@/components/common/head/head"
import MainLayout from "@/layout/NewDesignLayout"
import NarrowDown from "@/components/common/generalButton/NarrowDown"
import errorCodeMsg from "@/utils/error-code-msg"
import LoadingDialog from "@/components/common/loading/LoadingDialog"
import elDialogPrompt from "@/components/common/el-dialog-prompt"
import SystemManageApi from "@/api/SystemManageApi"
import GoogleCalendarAuthRuleFactory from "@/rules/rule-tenant-google-calendar-auth-edit"

export default {
  name: "TenantGoogleCalendarAuthEdit",
  components: {
    Menubar: Menubar,
    LvoryBut: LvoryBut,
    HeadTitle: HeadTitle,
    MainLayout: MainLayout,
    NarrowDown: NarrowDown,
    LoadingDialog: LoadingDialog,
    elDialogPrompt: elDialogPrompt
  },
  data() {
    return {
      isClearBtn: false,
      saveIsShow: false,
      saveMsgParam: this.$t("message.common.validation.updateMessage", {
        field: this.$t('label.system.tenant.googleAuth.googleAuth')
      }),
      deleteIsShow: false,
      deleteMsgParam: this.$t("message.common.validation.confDelete", {
        field: this.$t('label.system.tenant.googleAuth.googleAuth')
      }),
      showLoading: false,
      rules: GoogleCalendarAuthRuleFactory.googleCalendarAuthRules(this),
      tenantId: null,
      form: {
        domain: null,
        clientId: null,
        secretKey: null
      }
    }
  },
  created() {
    var breadcrumb = [
      {
        path: "/",
        title: "label.router.home",
      },
      {
        path: "/system/setting/various",
        title: "label.router.set",
      },
      {
        path: "",
        title: "label.router.comprehensive",
      },
      {
        path: "/system/tenants/search",
        title: "label.router.Thetenant",
      },
      {
        path: "",
        title: "label.router.tenantDetail",
      },
      {
        path: "",
        title: "label.router.GoogleCalendarAuthEdit",
      },
    ];

    if (this.$IsTenantUser()) {
      breadcrumb.splice(2,1)
    }
    this.$store.dispatch("menuActive/restBreadcrumb", breadcrumb)
  },
  mounted() {
    this.tenantId = this.$route.params.tenantId
    this.getGoogleCalendarAuth()
  },
  methods: {

    getGoogleCalendarAuth() {
      this.showLoading = true
      SystemManageApi.detailGoogleCalendarAuth(this.tenantId)
      .then(({data}) => {
        if (data.body != null && data.body != undefined && data.body != "") {
          this.form.domain = data.body.domain
          this.form.clientId = data.body.clientID
          this.form.secretKey = data.body.secretKey
          this.isClearBtn = true
        } else {
          this.isClearBtn = false
        }
      })
      .catch((error) => {
        this.isClearBtn = false
        errorCodeMsg(error, this)
      })
      .finally(() => {
        this.showLoading = false
      })
    },

    deleteGoogleCalendarAuth() {
      this.deleteIsShow = true
    },

    deleteAuthInfo() {
      let request = {
        tenantId: this.tenantId,
        domain: null,
        clientID: null,
        secretKey: null
      }
      this.doneEditGoogleCalendarAuth(request)
    },

    editGoogleCalendarAuth() {
      this.$refs["ruleForm"].validate((valid) => {
        alert(valid);
        if (valid || (this.$IsNullOrEmpty(this.form.domain) && this.$IsNullOrEmpty(this.form.clientId) && this.$IsNullOrEmpty(this.form.secretKey))) {
          this.saveIsShow = true
        }
      })
    },

    editAuthInfo() {
      let request = {
        tenantId: this.tenantId,
        domain: this.form.domain,
        clientID: this.form.clientId,
        secretKey: this.form.secretKey
      }
      this.doneEditGoogleCalendarAuth(request)
    },

    doneEditGoogleCalendarAuth(req) {
      let request = {
        tenantId: req.tenantId,
        domain: req.domain,
        clientID: req.clientID,
        secretKey: req.secretKey
      }
      this.showLoading = true
      SystemManageApi.updateGoogleCalendarAuth(request)
      .then(({data}) => {
        if (data.statusCode == "Success") {
          if (request.domain == null && request.clientID == null && request.secretKey == null) {
            this.clearGoogleCalendarAuth()
            this.deleteSuccess()
            this.isClearBtn = false
          } else {
            this.isClearBtn = true
            this.saveSuccess()
          }
        } else {
          if (data.statusCode == "Failure.Failure_AuthParameterIncorrect" ||
              data.statusCode == "Failure.Failure_GoogleAuthFailed") {
            this.saveFailed()
          }
        }
      })
      .catch((error) => {
        errorCodeMsg(error, this)
      })
      .finally(() => {
        this.showLoading = false
      })
    },

    clearGoogleCalendarAuth() {
      this.form.domain = null
      this.form.clientId = null
      this.form.secretKey = null
    },

    saveSuccess() {
      this.$messageIotSuccess(this.$t('message.common.saveSuccess', {
        field: this.$t('label.system.tenant.googleAuth.googleAuth')
      }))
    },

    deleteSuccess() {
      this.$messageIotSuccess(this.$t("message.common.deleteSuccess", {
        field: this.$t("label.system.tenant.googleAuth.googleAuth"),
      }))
    },

    saveFailed() {
      this.$messageIotError(this.$t('message.common.error.ERR_GOOGLE_CALENDAR_AUTH'))
    }

  }
}
</script>

<style scoped lang="scss">
.header-save-btn::v-deep {
  .my-button {
    width: 152px;
    height: 32px;
  }
}
.header-clear-btn::v-deep {
  .my-button {
    width: 152px;
    height: 32px;
  }
}
.c-auth-form::v-deep {
  .el-form-item {
    margin-bottom: 0px;
  }
  .el-input__inner {
    height: 44px !important;
  }
  .el-form-item__label {
    font-size: 16px;
  }
}
.c-auth-save-btn {
  margin-left: 188px;
  margin-top: 60px;
}
.domain {
  color: #525250;
  font-size: 14px;
}
.client-id::v-deep {
  .el-input .el-input__inner {
    width: 528px;
  }
}
</style>
